import moment from "moment";

export const getHoursBetweenDates = (start: string, end: string) => {
	return moment.duration(moment(end).diff(moment(start))).asHours();
};
